import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { Button } from "@mui/material";
import { styled as style } from "@mui/material/styles";
import { useMutation } from "react-query";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, Button as RsuiteBtn } from "rsuite";
import Logger from "../../libraries/Logger";
import apiClient from "../../libraries/ApiClient";
import apiOtherClient from "../../libraries/ApiOtherClient";
import { NoticeDataContext } from "../../contexts/NoticeDataContext";
import dayjs from "dayjs";
import { set } from "date-fns";
import { ModelContext } from "../../contexts/ModelContext";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px;
  position: sticky;
  top: 0px;
  .title {
    font-size: 20px;
  }
  .btn {
    display: flex;
    justify-content: space-between;
    width: 150px;
  }
  @media (max-width: 1200px) {
    top: 50px;
    background-color: #fff;
    z-index: 8;
  }
`;

const CssCancelButton = style(Button)({
  fontSize: 12,
  borderColor: "#057AFF",
  backgroundColor: "#fff",
  padding: "3px 0px",
  "&:hover": {
    borderColor: "#1570EF",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
});

const CssSaveButton = style(Button)({
  fontSize: 12,
  backgroundColor: "#057AFF",
  padding: "4px 0px",
  boxShadow: "none",
  borderColor: "#057AFF",

  "&:hover": {
    backgroundColor: "#1570EF",
    cursor: "pointer",
    boxShadow: "none",
    borderColor: "#057AFF",
  },
});

function ReferralEditTitle({
  dataFromBody,
  sendBasicData,
  sendOperativeData,
  sendMediaData,
  sendPreoperativeMediaData,
  sendPostoperativeMediaData,
  sendPdfData,
  detailData,
  isDetailReady,
}) {
  const apiUrl = import.meta.env.VITE_API_ROOT_URL;
  const location = useLocation();
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [accountId, setAccountId] = useState("");
  const [rowId, setRowId] = useState("");
  const [successCode, setSuccessCode] = useState(0);
  const [selfIdentities, setSelfIdentities] = useState([]);

  const [open, setOpen] = useState(false);
  const [isLoadingOpen, setIsLoadingOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { nData, setNData, refreshNData, setRefreshNData } =
    useContext(NoticeDataContext);
  const {
    pushEditApi,
    setPushEditApi,
    backListPage,
    setBackListPage,
    setOpenSecondModel,
    setOpenAskSaveModel,
    changeData,
    setChangeData,
    setLoading,
  } = useContext(ModelContext);

  const [updateReferralCode, setUpdateReferralCode] = useState(1);
  const [postOperativeCode, setPostOperativeCode] = useState(1);
  const [messageMediaCode, setMessageMediaCode] = useState(1);
  const [preOperativeMediaCode, setPreOperativeMediaCode] = useState(1);
  const [postOperativeMediaCode, setPostOperativeMediaCode] = useState(1);
  const [pdfCode, setPdfCode] = useState(1);
  const [click, setClick] = useState(false);

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
    setAccountId(JSON.parse(localStorage.getItem("auth"))?.AccountRowId);
    setSelfIdentities(JSON.parse(localStorage.getItem("auth"))?.SelfIdentities);
    const params = new URLSearchParams(location.search);
    setRowId(params.get("rowId"));
  }, []);

  useEffect(() => {
    if (!pushEditApi || !changeData) {
      return;
    }
    // 自動存檔(狀態列的「立即存檔」)也必須等資料載入完成，否則會用空值覆蓋既有資料。
    if (!isDetailReady) {
      alert("轉診資料尚未載入完成，請稍候再存檔");
      setLoading(false);
      setPushEditApi(false);
      return;
    }
    sendFormData({
      sendBasicData,
      sendOperativeData,
      sendPostoperativeMediaData,
      sendPreoperativeMediaData,
    });
  }, [pushEditApi]);

  useEffect(() => {
    const lists = sendOperativeData?.Angiemphraxis?.map(
      (item) => item.List
    )?.flat(2);
    let Location = lists?.filter((v) => v.Location === 0);
    let TiciScore = lists?.filter((v) => v.TiciScore === 0);

    if (sendOperativeData?.Angiemphraxis?.some((v) => v.Name === "BA")) {
      if (Location?.length > 1 || TiciScore?.length > 0) {
        setSuccessCode(1);
      } else {
        setSuccessCode(0);
      }
    } else {
      if (Location?.length > 0 || TiciScore?.length > 0) {
        setSuccessCode(1);
      } else {
        setSuccessCode(0);
      }
    }
  }, [sendOperativeData?.Angiemphraxis]);

  useEffect(() => {
    const UploadPreoperativeImageLength = sendPreoperativeMediaData?.length;
    const PreoperativeImageLength =
      detailData?.Data?.PostoperativeParameters?.PreoperativeImage?.length;

    if (
      PreoperativeImageLength != undefined &&
      UploadPreoperativeImageLength != undefined
    ) {
      if (PreoperativeImageLength + UploadPreoperativeImageLength > 10) {
        setSuccessCode(1002);
        return;
      }
    }

    const UploadPostoperativeImageLength = sendPostoperativeMediaData?.length;
    const PostoperativeImageLength =
      detailData?.Data?.PostoperativeParameters?.PostoperativeImage?.length;

    if (
      PostoperativeImageLength != undefined &&
      UploadPostoperativeImageLength != undefined
    ) {
      if (PostoperativeImageLength + UploadPostoperativeImageLength > 10) {
        setSuccessCode(1003);
        return;
      }
    }

    setSuccessCode(0);
  }, [sendPreoperativeMediaData, sendPostoperativeMediaData]);

  function hasDecimal(number) {
    const numberStr = number?.toString();

    const decimalPattern = /\./;

    return decimalPattern.test(numberStr);
  }

  //console.log(sendBasicData);
  const version = import.meta.env.VITE_VERSION;

  const sendFormData = async ({
    sendBasicData,
    sendOperativeData,
    sendPostoperativeMediaData,
    sendPreoperativeMediaData,
  }) => {
    let resOne;
    let resTwo;
    let postoperativeFdres;
    let preoperativeFdres;
    let pdfFdres;

    // 轉診資料尚未載入完成(或載入失敗)時，sendBasicData 會是空的，
    // 送出去會把後端既有的姓名、身分證字號等欄位清空，這裡直接擋下。
    if (!isDetailReady || !sendBasicData?.RowId) {
      alert("轉診資料尚未載入完成，請稍候再存檔");
      setIsLoadingOpen(false);
      setLoading(false);
      setPushEditApi(false);
      return;
    }

    if (
      +successCode === 0 ||
      hasDecimal(sendBasicData.Nihss) ||
      hasDecimal(sendBasicData.InjectDose) ||
      hasDecimal(sendBasicData.Weight)
    ) {
      const dataOne = {
        Data: sendBasicData,
      };
      resOne = await apiClient.postAes(
        `api/referral/UpdateReferral/Security`,
        dataOne
      );

      console.log(resOne);
      if (resOne?.data?.Data?.MessageRowId !== "" && sendMediaData.length > 0) {
        const mediaFd = new FormData();

        let messageRowId = resOne?.data?.Data?.MessageRowId;
        sendMediaData.forEach((image) => {
          mediaFd.append("ByFiles", image);
        });
        mediaFd.append("DataRowId", messageRowId);
        mediaFd.append("AccountRowId", accountId);
        mediaFd.append("IsInsert", false);
        mediaFd.append("Type", 2);

        apiClient.logOfActionWithoutId("Upload", "messageMediaBefore", {
          version,
          token,
          rowId,
        });

        try {
          const mediaFdres = await axios.post(
            `${apiUrl}api/referral/Upload`,
            mediaFd,
            {
              headers: {
                Authorization: `${token}`,
              },
            }
          );
          apiClient.logOfActionWithoutId("Upload", "messageMediaCompleted", {
            version,
            token,
            rowId,
          });
          if (+mediaFdres?.data?.Code !== 0) {
            apiClient.logOfActionWithoutId("Upload", "messageMediaFailed", {
              responseCode: +mediaFdres?.data?.Code,
              version,
              token,
              rowId,
            });
            alert("留言板檔案存檔失敗");
            setIsLoadingOpen(false);
            setMessageMediaCode(0);
            setLoading(false);
            setLoading(false);
            setPushEditApi(false);
            return;
          }
        } catch (e) {
          apiClient.logOfActionWithoutId("Upload", "messageMediaFailedCatch", {
            version,
            token,
            rowId,
          });
          if (e.response?.status !== 200) {
            alert("留言板檔案存檔失敗");
            setIsLoadingOpen(false);
            setLoading(false);
            setPushEditApi(false);
            setMessageMediaCode(1);
            return;
          }
        }
      }
      if (resOne?.status === 401) {
        alert("您的授權已失效，請重新登入");
        navigate("/Login");
        setLoading(false);
        setPushEditApi(false);
        return;
      }
      if (resOne?.status !== 200 || +resOne?.data?.Code !== 0) {
        alert("基本資料存檔失敗");
        setIsLoadingOpen(false);
        setLoading(false);
        setPushEditApi(false);
        return;
      }

      if (
        (selfIdentities?.includes("tbc_doctor") &&
          sendOperativeData?.IsIa !== null) ||
        (selfIdentities?.includes("nurse") && sendOperativeData?.IsIa !== null)
      ) {
        if (updateReferralCode === 1) {
        }
        const dataTwo = {
          Data: sendOperativeData,
        };

        resTwo = await apiClient.postAes(
          "api/referral/SetPostoperative/Security",
          dataTwo
        );
        if (resTwo?.status !== 200 || +resTwo?.data?.Code !== 0) {
          alert("術後病情存檔失敗");
          setIsLoadingOpen(false);
          setPostOperativeCode(0);
          setLoading(false);
          setPushEditApi(false);
          return;
        }

        const preoperativeFd = new FormData();
        sendPreoperativeMediaData.forEach((image) => {
          preoperativeFd.append("ByFiles", image);
        });
        preoperativeFd.append(
          "DataRowId",
          resTwo?.data?.Data?.PostoperativeRowId
        );
        preoperativeFd.append("AccountRowId", accountId);
        preoperativeFd.append("IsInsert", false);
        preoperativeFd.append("Type", 4);

        apiClient.logOfActionWithoutId("Upload", "preOperativeMediaBefore", {
          version,
          token,
          rowId,
        });
        try {
          if (sendPreoperativeMediaData.length > 0) {
            preoperativeFdres = await axios.post(
              `${apiUrl}api/referral/Upload`,
              preoperativeFd,
              {
                headers: {
                  Authorization: `${token}`,
                },
              }
            );
            apiClient.logOfActionWithoutId(
              "Upload",
              "preOperativeMediaCompleted",
              {
                version,
                token,
                rowId,
              }
            );
            if (+preoperativeFdres?.data?.Code !== 0) {
              apiClient.logOfActionWithoutId(
                "Upload",
                "preOperativeMediaFailed",
                {
                  responseCode: +preoperativeFdres?.data?.Code,
                  version,
                  token,
                  rowId,
                }
              );
              alert("術前檔案存檔失敗");
              setIsLoadingOpen(false);
              setLoading(false);
              setPushEditApi(false);
              return;
            }
          }
        } catch (e) {
          apiClient.logOfActionWithoutId(
            "Upload",
            "preOperativeMediaFailedCatch",
            {
              version,
              token,
              rowId,
            }
          );
          if (e.response?.status !== 200) {
            alert("術前檔案存檔失敗");
            setIsLoadingOpen(false);
            setPreOperativeMediaCode(1);
            setLoading(false);
            setPushEditApi(false);
            return;
          }
        }

        const postoperativeFd = new FormData();
        sendPostoperativeMediaData.forEach((image) => {
          postoperativeFd.append("ByFiles", image);
        });
        postoperativeFd.append(
          "DataRowId",
          resTwo?.data?.Data?.PostoperativeRowId
        );
        postoperativeFd.append("AccountRowId", accountId);
        postoperativeFd.append("IsInsert", false);
        postoperativeFd.append("Type", 3);
        apiClient.logOfActionWithoutId("Upload", "postOperativeMediaBefore", {
          version,
          token,
          rowId,
        });
        try {
          if (sendPostoperativeMediaData.length > 0) {
            postoperativeFdres = await axios.post(
              `${apiUrl}api/referral/Upload`,
              postoperativeFd,
              {
                headers: {
                  Authorization: `${token}`,
                },
              }
            );
            apiClient.logOfActionWithoutId(
              "Upload",
              "postOperativeMediaCompleted",
              {
                version,
                token,
                rowId,
              }
            );
            if (+postoperativeFdres?.data?.Code !== 0) {
              apiClient.logOfActionWithoutId(
                "Upload",
                "postOperativeMediaFailed",
                {
                  responseCode: +postoperativeFdres?.data?.Code,
                  version,
                  token,
                  rowId,
                }
              );
              alert("術後檔案存檔失敗");
              setIsLoadingOpen(false);
              setLoading(false);
              setPushEditApi(false);
              return;
            }
          }
        } catch (e) {
          apiClient.logOfActionWithoutId(
            "Upload",
            "postOperativeMediaFailedCatch",
            {
              version,
              token,
              rowId,
            }
          );
          if (e.response?.status !== 200) {
            alert("術後檔案存檔失敗");
            setIsLoadingOpen(false);
            setPostOperativeMediaCode(1);
            setLoading(false);
            setPushEditApi(false);
            return;
          }
        }
      }
      const pdfFd = new FormData();
      sendPdfData.forEach((image) => {
        pdfFd.append("ByFiles", image);
      });
      pdfFd.append("DataRowId", rowId);
      pdfFd.append("AccountRowId", accountId);
      pdfFd.append("IsInsert", false);
      pdfFd.append("Type", 5);
      apiClient.logOfActionWithoutId("Upload", "pdfBefore", {
        version,
        token,
        rowId,
      });

      try {
        if (sendPdfData.length > 0) {
          pdfFdres = await axios.post(`${apiUrl}api/referral/Upload`, pdfFd, {
            headers: {
              Authorization: `${token}`,
            },
          });
          apiClient.logOfActionWithoutId("Upload", "pdfCompleted", {
            version,
            token,
            rowId,
          });

          if (+pdfFdres?.data?.Code !== 0) {
            apiClient.logOfActionWithoutId("Upload", "pdfFailed", {
              responseCode: +pdfFdres?.data?.Code,
              version,
              token,
              rowId,
            });
            alert("pdf存檔失敗");
            setIsLoadingOpen(false);
            setLoading(false);
            setPushEditApi(false);
            return;
          }
        }
      } catch (e) {
        apiClient.logOfActionWithoutId("Upload", "pdfFailedCatch", {
          version,
          token,
          rowId,
        });
        if (e.response?.status !== 200) {
          alert("pdf存檔失敗");
          setIsLoadingOpen(false);
          setPdfCode(0);
          setLoading(false);
          setPushEditApi(false);
          return;
        }
      }
    }

    if (
      +successCode === 0 &&
      updateReferralCode === 1 &&
      postOperativeCode === 1 &&
      messageMediaCode === 1 &&
      preOperativeMediaCode === 1 &&
      postOperativeMediaCode === 1 &&
      pdfCode === 1 &&
      resTwo === undefined &&
      pdfFdres === undefined
    ) {
      setRefreshNData(0);
      if (pushEditApi) {
        setOpenAskSaveModel(false);
        setLoading(false);
        setChangeData(false);
      }
      alert("更改成功");
      if (backListPage) {
        navigate("/ReferralDataList");
      } else {
        setOpenSecondModel(true);
      }

      setIsLoadingOpen(false);
    } else if (+successCode === 1) {
      setIsLoadingOpen(false);
      alert("請選擇阻塞血管位置及打通程度");
    } else if (+successCode === 1002) {
      setIsLoadingOpen(false);
      alert("術前圖片不可超過 10 筆");
    } else if (+successCode === 1003) {
      setIsLoadingOpen(false);
      alert("術後圖片不可超過 10 筆");
    } else if (
      +successCode === 0 &&
      updateReferralCode === 1 &&
      postOperativeCode === 1 &&
      messageMediaCode === 1 &&
      preOperativeMediaCode === 1 &&
      postOperativeMediaCode === 1 &&
      pdfCode === 1 &&
      (+resTwo?.data?.Code === 0 || +pdfFdres?.data?.Code === 0)
    ) {
      //console.log("歷史");
      if (pushEditApi) {
        setOpenAskSaveModel(false);
        setLoading(false);
        setChangeData(false);
      }
      alert("更改成功");
      if (backListPage) {
        navigate("/history");
      } else {
        setOpenSecondModel(true);
      }
      setIsLoadingOpen(false);
    }
  };
  const { data, mutate, isLoading, isSuccess } = useMutation(sendFormData);
  //console.log(data);

  useEffect(() => {
    // if (formSuccessCode === 0) {
    //   if (
    //     (mediaSuccessMediaCode === 0 || mediaSuccessMediaCode === null )&&
    //     data?.resTwo === undefined
    //   ) {
    //     setRefreshNData(0);
    //     alert("更改成功1");
    //     navigate("/ReferralDataList");
    //     setIsLoadingOpen(false);
    //   }
    // else if (isSuccess && +successCode === 1) {
    //   setIsLoadingOpen(false);
    //   alert("請選擇阻塞血管位置及打通程度");
    // } else if (isSuccess && +successCode === 1002) {
    //   setIsLoadingOpen(false);
    //   alert("術前圖片不可超過 10 筆");
    // } else if (isSuccess && +successCode === 1003) {
    //   setIsLoadingOpen(false);
    //   alert("術後圖片不可超過 10 筆");
    // } else if (
    //   +successCode === 0 &&
    //   (formSuccessCode === 0 || formSuccessCode === null) &&
    //   (mediaSuccessMediaCode === 0 || mediaSuccessMediaCode === null) &&
    //   +data?.resTwo?.data?.Code === 0
    // ) {
    //   //console.log("歷史");
    //   alert("更改成功3");
    //   navigate("/history");
    //   setIsLoadingOpen(false);
    // }
    // }else if (mediaSuccessMediaCode === 0) {
    // }
  }, [click]);

  return (
    <Container>
      <div className="title">
        <div style={{ fontSize: "16px" }}>{dataFromBody?.CaseCode}編輯</div>
        <div style={{ fontSize: "10px", padding: "8px 0px 0px 0px" }}>
          {dataFromBody?.Name}
          {dataFromBody?.Sex === 1 ? <i className="fa-solid fa-mars"></i> : ""}
          {dataFromBody?.Sex === 2 ? <i className="fa-solid fa-venus"></i> : ""}
          {dataFromBody?.IdNo}
        </div>
      </div>
      <div className="btn">
        <div>
          <CssCancelButton
            size="small"
            variant="outlined"
            style={{ minWidth: "70px" }}
            onClick={handleOpen}
          >
            取消
          </CssCancelButton>
        </div>
        <div style={{ marginLeft: "16px" }}>
          <CssSaveButton
            size="small"
            variant="contained"
            style={{ minWidth: "70px" }}
            onClick={() => {
              mutate({
                sendBasicData,
                sendOperativeData,
                sendPostoperativeMediaData,
                sendPreoperativeMediaData,
                sendPdfData,
              });
              setIsLoadingOpen(true);
              setBackListPage(true);
            }}
            disabled={isLoading || !isDetailReady}
          >
            存檔
          </CssSaveButton>
        </div>
      </div>
      <Modal open={open} onClose={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>提示資訊</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            height: "100px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <div style={{ fontSize: "18px" }}>若有資料未儲存</div>
          <div style={{ fontSize: "14px" }}>「確認」取消將不保留您的資料</div>
        </Modal.Body>
        <Modal.Footer>
          <RsuiteBtn
            onClick={() => {
              navigate("/ReferralDataList");
            }}
            appearance="primary"
          >
            確認
          </RsuiteBtn>
          <RsuiteBtn onClick={handleClose}>取消返回</RsuiteBtn>
        </Modal.Footer>
      </Modal>
      <Modal open={isLoadingOpen} backdrop="static">
        <Modal.Body
          style={{
            height: "100px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <div style={{ fontSize: "14px" }}>資料儲存中</div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </Container>
  );
}

export default ReferralEditTitle;
